import { h, VNode } from 'preact';
import { AppStoreLinks } from './AppStoreLinks';

export function SuccessView(): VNode {
  return (
    <div className="container">
      <div className="subhead" id="errorText">
        Request sent!
      </div>

      <div className="subhead">Whats next?</div>
      <div className="subhead" id="bgWaiting">
        Wait until you recieve an email with a reply...
      </div>

      <div style={{ marginTop: '30px' }} className="subhead">
        Find more events:
      </div>
      <AppStoreLinks />
    </div>
  );
}
